import React, { useMemo } from "react";
import LoaderSubComponent from "components/general/LoaderSubComponent";
import MirsTable from "components/general/table/Table";
import CaptionTable from "components/general/table/CaptionTable";
import Status from "components/presentation/Status";
import { isStartListStatus, isLiveStatus } from "helpers/status";
import { isLess4Intermediates, getIsEventRelay } from 'components/sports/swm/helper/SwmHelpers'
import ProgressBar from 'components/general/ProgressBar';
import LiveCheckBox from "components/general/LiveCheckbox";
//General
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

//INDIVIDUALS 
import { TableColumnsStartList as ColumnsStartList, TableColumnsLive as ColumnsLive, TableColumnsFinish as ColumnsFinish } from 'components/sports/swm/events/individual/results/Columns'
import { TableExpanded as TBEIndividual } from 'components/sports/swm/events/individual/results/TableExpanded'
//RELAYS
import { TableColumnsRelayStart as ColumnsRelayStart, TableColumnsRelayLive as ColumnsRelayLive, TableColumnsRaceRelayFinish as ColumnsRelayFinish } from 'components/sports/swm/events/relay/results/ColumnsRelay'
import { TableExpanded as TBERelay } from 'components/sports/swm/events/relay/results/TableExpanded'
import { findArray } from "helpers/utils";



const getConfiguration = (data, rsc, resultStatus, isLess4) => {

    const isEventRelay = getIsEventRelay(rsc);
    const columnsAdded = data?.config?.extendedConfig ? data.config.extendedConfig.sort((a, b) => a.pos - b.pos) : []
    // const resultStatus = data?.results?.status?.code;
    const scheduleStatus = data?.results?.schedule?.status?.code;


    let configuration = {
        caption: null,
        columns: [],
        //subComponent: null,
        hiddenColumns: [],
        sortBy: [],
        filters: {
            ei_type: ['NONE'],
            ei_code: ['NONE']
        },
        configs: {
            isStartList: isStartListStatus(resultStatus),
            columnsAdded: columnsAdded,
            previousCurrent: false,
        }
    };

    configuration.filters = {
        ei_type: ['DISPLAY'],
        ei_code: ['LEADER']
    };


    configuration.caption = <CaptionTable
        leftCol={<h3 className="text-dark">{data && data?.results?.eventUnit?.shortDescription}</h3>}
        rightCol={<Status typeToPrint="result" scheduleStatus={scheduleStatus} resultStatus={resultStatus} />}
    />

    configuration.sortBy = isStartListStatus(resultStatus)
        ? [{ id: 'StartOrder', desc: false }]
        : [{ id: 'Rank', desc: false }]



    if (isEventRelay) {
        configuration.columns = isStartListStatus(resultStatus)
            ? ColumnsRelayStart()
            : isLiveStatus(resultStatus)
                ? ColumnsRelayLive(columnsAdded, isLess4)
                : ColumnsRelayFinish(columnsAdded)
    } else {
        configuration.columns = isStartListStatus(resultStatus)
            ? ColumnsStartList()
            : isLiveStatus(resultStatus)
                ? ColumnsLive(columnsAdded, isLess4)
                : ColumnsFinish(columnsAdded)

    }
    return configuration;
};


const SwmResults = ({ data }) => {
    const { mirs_rsc } = useUrlFriendlyToParameters()
    const resultStatus = data?.results?.status?.code;
    const rsc = data?.results?.eventUnitCode;
    const isLess4 = isLess4Intermediates(mirs_rsc);
    const configEvent = useMemo(() => getConfiguration(data, mirs_rsc, resultStatus, isLess4), [resultStatus]);

    // Create a function that will render our row sub components
    const renderRowSubComponent = React.useCallback(({ row }) => {

        let componentExpanded = '';
        if (getIsEventRelay(mirs_rsc)) {
            componentExpanded = < TBERelay row={row?.original} config={configEvent.configs.columnsAdded} />
        } else {
            componentExpanded = <TBEIndividual row={row?.original} config={configEvent.configs.columnsAdded} />
        }
        return (
            <LoaderSubComponent component={componentExpanded} />
        )
    }, [resultStatus]);



    const getProgessBarConfiguration = () => {
        let config = {
            distance: {
                unit: 'm',
                exceptions: [
                    { pos: 'S', label: 'HeaderStart' },
                    { pos: 'F', label: 'HeaderFinish' },
                ]
            },
            hideProgress: false,
            hidePassed: true,
            style: 'box-data',
            numColVisibles: { sm: 1, lg: 3 }
        }
        config.breakpoints = {
            0: { slidesPerView: 1 },
            768: { slidesPerView: 3 },
            1024: { slidesPerView: 3 },
        }
        return config;
    }
    const progressBarConfig = getProgessBarConfiguration();



    return (
        <>
            {data?.results?.items
                ? (
                    <>

                        {/* ProgressBar */}
                        {isLiveStatus(resultStatus) && !isLess4 && data?.progressBar && <ProgressBar id={`mirs-progressbar-${mirs_rsc}`} data={data.progressBar} config={progressBarConfig} dinamic={true} />}
                        {isLiveStatus(resultStatus) && !isLess4 && data?.progressBar && <LiveCheckBox id={`mirs-livecheckbox-${mirs_rsc}`} />}

                        < MirsTable
                            //Dato to show by row
                            data={data.results.items}
                            //Columnas a visualizar 
                            columns={configEvent.columns}
                            //subcomponente a renderizar, extended
                            renderRowSubComponent={renderRowSubComponent}
                            //Key by row necesary in order to no paint innecesary
                            keyRow='participant-code'
                            //Splits to show
                            //colsExtendedVisible={extendedColsVisibles}
                            //Component caption
                            caption={configEvent.caption}
                            //Columns to hidde 
                            //hiddenColumns={hiddenColumns}
                            //When show tble is sorted by 
                            initialSortBy={configEvent.sortBy}
                            id={`mirs-table-result-${rsc}`}
                            showNavExtendedData={false}
                            hasRelatedTimeline={isLiveStatus(resultStatus) ? true : false}
                        />

                    </>
                ) : (
                    ''
                )
            }
        </>
    );
};

export default SwmResults;
